<script>
export default {
  name: "Page",
  props: ['page', 'pages', 'click'],
  computed: {
    firstPage() {
      if (this.page <= 1) return null;
      return 0;
    },
    lastPage() {
      if (this.pages <= 1) return null;
      if (this.page + 3 > this.pages) return null;
      return this.pages - 1;
    },
    steps() {
      let startPage = this.page - 1;
      if (startPage < 0) startPage = 0;
      let endPage = this.page + 1;
      if (endPage + 1 > this.pages) endPage = this.pages - 1;

      let steps = [];
      for (let i=startPage; i<=endPage; i++) {
        steps.push(i);
      }

      return steps;
    }
  }
}
</script>

<template>
  <div class="pages">
    <template v-if="firstPage != null">
      <div class="page" data-page="0" @click="click(0)">1</div>
      <div class="space" v-if="firstPage + 1 !== steps[0]">...</div>
    </template>

    <div :class="'page ' + (page === p ? 'current' : '')"
         v-for="p in steps" :data-page="p" @click="page !== p ? click(p) : null">
      {{ p + 1 }}
    </div>

    <template v-if="lastPage != null">
      <div class="space" v-if="page + 2 !== lastPage">...</div>
      <div class="page" :data-page="lastPage" @click="click(lastPage)">{{ lastPage + 1 }}</div>
    </template>
  </div>
</template>